<template>
    <div class='cloudLab_wrap'>
        <div class='bg'>
            <div class='title'>云实验室</div>
            <div class='list_wrap'>
                <div><i class='iconfont icon-dian'></i><span>采用开源架构代码与科研成果白盒分享</span></div>
                <div><i class='iconfont icon-dian'></i><span>支持python ,R语言实现交互式教学场景</span></div>
                <div><i class='iconfont icon-dian'></i><span>基于云计算架构使用容器技术满足DATA&Al科研实训</span></div>
                <div><i class='iconfont icon-dian'></i><span>支持课程资源和教学管理，实现教学进度的实时追踪和跟进</span>
                </div>
            </div>
            <div class='button_wrap'>
                <div class='into_system' @mouseenter='oneStatus = 2' @mouseleave='oneStatus = 1'>
                    <div v-if="oneStatus == 1">数据科学实验系统</div>
                    <div class="system_text" @click="toLab(1)" v-if="oneStatus == 2">
                        <div>数据科学知识的一站式学习平台，从Python和R语言的基础语法开始，逐步延伸到深层面的数据分析方法教学，独特的理论与案例相结合的教学方式可大程度地提升学习效率。</div>
                        <div class="enter_button">点击进入 <i class="el-icon-arrow-right"></i></div>
                    </div>
                </div>
                <el-divider direction="vertical"></el-divider>
                <div class="into_system"  @mouseenter="twoStatus = 2" @mouseleave="twoStatus = 1">
                    <div v-if="twoStatus == 1">人工智能实训系统</div>
                    <div class="system_text" v-if="twoStatus == 2" @click="toLab(2)" >
                        <div>Python是集统计分析与图形显示于一体的计算机编程语言。本平台从语言基础和算法模型教学，逐渐深入到自然语言处理、机器视觉等，建立起─套完整的人工智能实训课程。</div>
                        <div class="enter_button">点击进入 <i class="el-icon-arrow-right"></i></div>
                    </div>
                </div>
                <el-divider direction="vertical"></el-divider>
                <div class="into_system"   @mouseenter="threeStatus = 2" @mouseleave="threeStatus = 1" @click="toCompute">
                    <div v-if="threeStatus == 1">智能计算资源专区</div>
                    <div class="system_text" v-if="threeStatus == 2">
                        <div>智能计算资源专区为大容量、高性能计算平台，包含基础版（Jupyter Notebook运行资源1G）与进阶版（添加CPU、GPU计算资源），可满足用户的不同计算需求.</div>
                        <div  class="enter_button">点击进入 <i class="el-icon-arrow-right"></i></div>
                    </div>
                </div>
            </div>
            <div class="division_line">
                <el-divider><span>数据科学实验系统 &nbsp;&nbsp; & &nbsp;&nbsp; 人工智能实训系统</span></el-divider>
            </div>
        </div>
        <div class="sub_title">
            <span class="title_text">课程框架</span>
            <div >数据科学平台系统和人工智能实训系统的课程框架比较</div>
        </div>
        <div class="sub_nav_wrap flex-between" >
            <div :class="{'active_nav':navId == nav.id}" @click="navId = nav.id" v-for="nav in navList" :key="nav.id">
                <i :class="nav.iconName" class="iconfont"></i>
                <div>{{nav.title}}</div>
            </div>
        </div>
        <div class="sub_content" v-show="item.id == navId" v-for="item in navList" :key="item.id">
            <img :src="item.imgOne">
            <img :src="item.imgTwo">
        </div>
        <div class="manage_content">
            <div class="manage_wrap">
                 <div class="manage_title">
                     <span>教师后台管理</span>
                </div>
                <div class="manage_text">
                    平台教师后台管理模块功能全面，包含批量导入学生信息、创建教学班级、在线组建自定义课件、发布手动评分或自动评分任务、查看任务完成情况等，实现在线教学至知识点测评的教学一体化管理。
                </div>
            </div>
            <div class='img_wrap'>
                <div v-for='item in teacherList' :key='item.title' class='list_wrap'>
                    <div class='info_title'><span>{{ item.title }}</span>
                        <div v-if="item.title == '课件管理'">(即将开放)</div>
                    </div>
                    <div>
                        <li v-for='value in item.itemList' :key='value'><i class='iconfont icon-dian'></i>{{ value }}
                        </li>
                    </div>
                </div>
            </div>
        </div>
        <div class='img_show'></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            navId: 0,
            oneStatus: 1,
            twoStatus: 1,
            threeStatus: 1,
            navList: [{
                id: 0,
                title: '前置课程',
                iconName: 'icon-qingsongyuxi',
                imgOne: require('../../../assets/img/cloudLab/1.png'),
                imgTwo: require('../../../assets/img/cloudLab/2.png')
            }, {
                    id:1,
                    title:'基础课程',
                    iconName:'icon-jichu',
                    imgOne:require('../../../assets/img/cloudLab/3.png'),
                    imgTwo:require('../../../assets/img/cloudLab/4.png')
                },{
                    id:2,
                    title:'模块课程',
                    iconName:'icon-mokuai',
                    imgOne:require('../../../assets/img/cloudLab/5.png'),
                    imgTwo:require('../../../assets/img/cloudLab/6.png')
                },{
                    id:3,
                    title:'交叉课程',
                    iconName:'icon-jiaochabiao',
                    imgOne:require('../../../assets/img/cloudLab/7.png'),
                    imgTwo:require('../../../assets/img/cloudLab/8.png')
                }],
                teacherList:[{
                    title:'任务管理',
                    itemList:[
                        '支持创建任务、保存任务模板、定时发布任务等',
                        '教师依照任务内容自主选择自动评分或手动评分，其中自动评分任务支持多项评分指标',
                        '任务发布后，系统会通过通知模块自动提醒学生',
                        '系统自动统计任务完成情况且支持条件筛选，学生可在任务主页面查看任务得分'
                    ]
                },{
                    title:'班级管理',
                    itemList:[
                        '通过自定义班级信息创建不同班级',
                        '支持批量导入学生信息生成学生账号',
                        '可随时修改学生或班级信息'
                    ]
                }, {
                    title: '课件管理',
                    itemList: [
                        '根据教学内容创建不同课程信息',
                        '为不同课程添加本地文件或选取平台文件自主组课',
                        '本地文件上传后支持在线预览',
                        '可在不同设备登陆平台账号查看/修改/添加课件'
                    ]
                }],
        }
    },
    created() {

    },
    methods: {
        //进入智能计算资源专区
        toCompute() {
            // this.$router.push('/computeResource')
            this.$router.push('/other');
        },

        //进入实验系统
        toLab(id) {
            // this.$router.push('/other')
            this.$router.push({ path: '/cloudLabDetail', query: { modelId: id } });
        },

        //转至未开发页面
        toOther() {
            this.$router.push('/other');
        }
    }
}
</script>
<style lang="scss" scoped>
.sub_title{
    height: 100px;
    font-size: 18px;
    color: #333;
    text-align: center;
    line-height: 2.5;
    span{
        font-size: 33px;
        font-weight: bold;
        border-bottom: 3px solid #5277F7;
        padding-bottom: 2px;
        // margin-bottom: 30px;
    }
}
.division_line{
    margin-top: 60px;
    .el-divider{
        background: #5277F7;
        span{
            font-size: 18px;
            font-weight: bold;
            margin: 0px 20px;
        }
    }
}
.img_show{
    height: 800px;
    background: url(../../../assets/img/lab_item.png) 50% 50%/55% 60% no-repeat;
}
.manage_content{
    .manage_wrap{
        box-sizing: border-box;
        padding: 50px 350px 40px 350px;
        .manage_title{
            height: 150px;
            line-height: 150px;
            color: #333333;
            text-align: center;
            span{
                font-size: 28px;
                border-bottom: 5px solid #5277F7;
                font-weight: bold;
                padding-bottom: 8px;
            }
        }
        .manage_text{
            font-size: 20px;
            line-height: 1.7;
            color: #333333;
        }
    }
}
.img_wrap{
    height: 819px;
    background: url(../../../assets/img/lab_box.png) 0 0/100% 100% no-repeat;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 130px 130px 20px 231px;
    >div{
        width: 400px;
        color: white;
        line-height: 2.3;

        .icon-dian{
            font-weight: bold;
            font-size: 21px;
        }
        li{
            font-size: 18px;
        }
        .info_title{
            span{
                padding-bottom: 5px;
                font-size: 23px;
                border-bottom: 3px solid #fff;
            }
        }
    }
    >div:nth-child(3){
        width: 430px;
        position: relative;
        top: -10px;
    }
    >div:nth-child(2){
        position: relative;
        width: 500px;
        top: 465px;
        left: -50px;
        .li_wrap{
            display: flex;
            flex-wrap: wrap;
        }
    }
}
.sub_content{
    width: 100%;
    box-sizing: border-box;
    img{
        max-width: 100%;
        height: auto;
    }
}
.sub_nav_wrap{
    width: 100%;
    box-sizing: border-box;
    padding: 50px 400px 40px 400px;
    >div{
        width: 150px;
        height: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: #999999;

        i{
            font-size: 40px;
            margin-bottom: 5px;
        }
    }
    >div:hover{
        cursor: pointer;
        border-radius: 20px;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        color: #5277F7 !important;
    }
}
.active_nav{
    border-radius: 20px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    color: #5277F7 !important;
}
.bg{
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    background: url(../../../assets/img/labBg.png) 0 0/100% 100% no-repeat;
    .title{
        box-sizing: border-box;
        padding-top: 20vh;
        font-size: 50px;
        font-weight: 600;
        letter-spacing: 5px;
        padding-left:30vh;
        color: #5277F7;
    }
    .button_wrap{
        border-left: 15px solid #CF6EE8;
        margin-top: 15vh;
        margin-left:35vw;
        width: 55%;
        height: 130px;
        background: url(../../../assets/img/compute_button_wrap.png) 0 0/100% 100% no-repeat;
        align-items: center;
        justify-content: space-between;
        display: flex;
        .into_system{
            width: 30%;
            box-sizing: border-box;
            padding: 0px 40px;
            height: 130px;
            line-height: 130px;
            text-align: center;
            font-size: 20px;
            color: #333;
            font-weight: bold;
            .system_text{
                margin-top: 15px;
                font-weight: 10;
                color: white;
                font-size: 16px;
                line-height: 1.5;
                text-align: justify;
                font-family: '黑体';
                .enter_button{
                    text-align: right;
                    margin-top: 5px;
                }
                .enter_button:hover{
                    color: #5277F7;
                }
            }
        }
        .into_system:hover{
            cursor: pointer;
            width: 60%;
            background: #B095E7;
        }
        .el-divider{
            width: 3px;
            background: #333;
        }
    }
    .list_wrap{
        padding-left:30vh;
        margin-top: 40px;
        line-height: 2.5;
        font-size: 23px;
        color: #5277F7;
        i{
            margin-right: 5px;
            font-size: 23px;
        }
    }
}
.cloudLab_wrap {
    width: 100%;
    height: auto;
}
</style>
